import ReactHeap from "reactjs-heap";
import { getBooleanFromEnv, getVariableFromEnv } from "./common/utilities/env";

const environment = getVariableFromEnv("ENVIRONMENT");
const heapId = getVariableFromEnv("HEAP_ID");
const onPrem = getBooleanFromEnv("ON_PREM");

// Only initialize Heap if not on-premise and heap ID is provided
if (heapId && !onPrem && environment.toLowerCase() === "production") {
  ReactHeap.initialize(heapId);
}
